<template>
  <b-row>
    <b-col sm="12">

      <b-card body-class="py-2">
        <section class="list-view-heading">
          <ModuleViewHeading
            :module-id="access.module_id"
            :profile-id="access.profile_id"
            :reference="access.view_reference"
            summary-only
          />
          <div class="list-view-heading__controls">
            <div class="list-view-heading__actions">
              <TabHeaderActions />
            </div>
            <div class="list-view-heading__controls-end">
              <b-button variant="link"
                        class="list-view-icon-btn list-view-icon-btn--primary"
                        v-b-tooltip.hover.bottom
                        title="Agregar Interface"
                        aria-label="Agregar Interface"
                        @click="add()">
                <AppIcon name="add" />
              </b-button>
            </div>
          </div>
        </section>
      </b-card>

      <b-card header-tag="header" footer-tag="footer">
        <b-row>
          <b-col>
            <b-table class="mb-0 app-table crud-php-interfaces-table"
                    responsive="sm"
                    ref="table"
                    :stacked="isMobileViewport ? 'md' : false"
                    sticky-header="60vh"
                    :hover="true"
                    :small="true"
                    :fixed="false"
                    :items="table.items"
                    :fields="table.fields"
                    :busy="table.isBusy"
                    selectable
                    select-mode="single"
                    v-if="table.items.length || table.isBusy">

                <template v-slot:table-busy>
                  <div class="text-center text-danger my-2">
                    <b-spinner class="align-middle"></b-spinner>
                    <strong>Cargando...</strong>
                  </div>
                </template>

                <template v-slot:cell(id)="data">
                  <b>{{data.item.id}}</b>
                </template>

                <template v-slot:cell(blocked)="data">
                  <AppIcon name="lock" v-if="data.item.blocked" v-b-tooltip.hover title="Bloqueado" />
                </template>


                <template v-slot:cell(module)="data">
                  <b v-if="data.item.module_id">{{ data.item.module.name.toUpperCase() }}</b>
                </template>

                <template v-slot:cell(name)="data">
                  {{data.item.name}}
                </template>

                <template v-slot:cell(observations)="data">
                  <div v-if="data.item.observations">
                    <div v-if="data.item.observations.length >50" :title="data.item.observations">
                      <AppIcon name="chat-square-text" class="mr-1" font-scale="1.2" />
                      {{data.item.observations.substr(0, 150)}}
                    </div>
                    <div v-else>
                      {{data.item.observations}}
                    </div>
                  </div>
                </template>

                <template v-slot:cell(external_url)="data">
                  <div v-if="data.item.external_url">
                    <b-link :href="data.item.external_url" target="_blank" v-if="isMobileViewport">
                      <AppIcon name="external" class="mr-1" />Abrir
                    </b-link>
                    <b-link :href="data.item.external_url" target="_blank" v-else v-b-tooltip.hover.right title="Abrir URL externa">
                      <AppIcon name="external" />
                    </b-link>
                  </div>
                </template>

                <template v-slot:cell(log_url)="data">
                  <b-link :href="getLogUrl(data.item)" target="_blank" v-if="isMobileViewport">
                    <AppIcon name="clock-history" class="mr-1" />Ver log
                  </b-link>
                  <b-link :href="getLogUrl(data.item)" target="_blank" v-else v-b-tooltip.hover.right title="Ver log">
                    <AppIcon name="clock-history" />
                  </b-link>
                </template>

                <template v-slot:cell(f_action)="data">
                  <b-dropdown right
                              no-caret
                              size="sm"
                              variant="link"
                              boundary="window"
                              :toggle-class="isMobileViewport ? 'crud-php-interfaces-action-toggle-labeled' : 'app-table-action-toggle'"
                              :class="{ 'pull-right': !isMobileViewport }">
                    <template #button-content>
                      <AppIcon name="more_vert" :label="isMobileViewport ? 'Opciones' : 'Acciones'" :class="{ 'mr-1': isMobileViewport }" />
                      <span v-if="isMobileViewport">Opciones</span>
                    </template>

                    <b-dropdown-item @click="openCode(data.item)">
                      <AppIcon name="data_object" /> Código
                    </b-dropdown-item>

                    <b-dropdown-header>Log</b-dropdown-header>
                    <b-dropdown-item @click="openLog(data.item)">
                      <AppIcon name="visibility" /> Ver
                    </b-dropdown-item>
                    <b-dropdown-item @click="deleteLog(data.item)">
                      <AppIcon name="eraser-fill" class="text-danger" /> Vaciar
                    </b-dropdown-item>

                    <b-dropdown-header>Protección</b-dropdown-header>
                    <b-dropdown-item @click="blockedPHP(data.item)" v-if="!data.item.blocked">
                      <AppIcon name="lock-fill" /> Bloquear
                    </b-dropdown-item>
                    <b-dropdown-item @click="unlockedPHP(data.item)" v-else>
                      <AppIcon name="lock-fill" /> Desbloquear
                    </b-dropdown-item>

                    <b-dropdown-header>Acciones</b-dropdown-header>
                    <b-dropdown-item @click="edit(data.item)">
                      <AppIcon name="edit" /> Editar
                    </b-dropdown-item>
                    <b-dropdown-item @click="remove(data.item)">
                      <AppIcon name="delete" class="text-danger" /> Eliminar
                    </b-dropdown-item>
                  </b-dropdown>
                </template>
            </b-table>
            <EmptyState v-else title="No se encontraron registros" />
          </b-col>
        </b-row>
      </b-card>

      <b-card body-class="py-2">
        <div class="list-view-footer">
          <b-button type="button" variant="outline-dark" size="sm" @click="$router.go(-1)">
            <AppIcon name="back" class="mr-1" />Volver
          </b-button>
        </div>
      </b-card>

      <!-- ########################### -->
      <!-- #####     MODALES     ##### -->
      <!-- ########################### -->

      <!-- CRUD MAIN -->
      <b-modal v-model="modal.form.active"
              size="lg"
              :key="modal.form._id"
              :id="modal.form._id">
        <div slot="modal-header" minimize class="app-modal-header">
          <span class="app-modal-header__icon"><AppIcon name="edit" /></span>
          <h5 class="app-modal-header__title">{{this.modal.form.title}}</h5>
        </div>

        <b-row>
          <b-col md="12">
            <b-form-group label="Nombre">
              <b-form-input type="text"
                            size="sm"
                            v-model="crud.form.name"
                            required
                            placeholder="Ingresar un nombre">
              </b-form-input>
            </b-form-group>
          </b-col>

          <b-col md="12">
            <b-form-group label="Observaciones">
              <app-textarea
                v-model="crud.form.observations"
                size="sm"
                placeholder="Ingresar las observaciones"
              ></app-textarea>
            </b-form-group>
          </b-col>

          <b-col md="12">
            <FindObject render="search"
                        type="modules"
                        @select-object="loadModules($event)"
                        :where="conditionModulesActive"
                        :valueID="crud.form.module_id"/>
          </b-col>
        </b-row>
        <b-row>
          <b-col md="8">
            <b-form-group label="Key" description="El valor ingresado se envía a la url de acceso como un parametro ?key=<valor>. Si queda vacío no se envía.">
              <b-form-input type="test"
                            v-model="crud.form.key"
                            required
                            placeholder="Ingresar una key">
              </b-form-input>
            </b-form-group>
          </b-col>

          <b-col md="4">
            <b-form-group label="Altura" description="Ingresar una altura en numeros para el widget, en pixeles. Si el valor es cero, se ajusta al 100% del contenedor.">
              <b-input-group append="px" size="sm">
                <b-form-input type="number"
                              v-model="crud.form.height"
                              required
                              placeholder="Ingresar una altura">
                </b-form-input>
              </b-input-group>
            </b-form-group>
          </b-col>
        </b-row>

        <div slot="modal-footer">
          <b-button variant="outline-secondary" class="mr-1" @click="modal.form.active=false">Cancelar</b-button>
          <b-button variant="dark" @click="save()"><AppIcon name="save" class="mr-1" />Guardar</b-button>
        </div>
      </b-modal>

    </b-col>
  </b-row>
</template>

<script>
  import serviceAPI from './services'
  import Error from '@/handler/error'
  import Session from '@/handler/session'
  import Profiles from '@/config/profiles'
  import Modules from '@/config/modules'
  import Helper from '@/handler/helper'
  import moment from 'moment'
  import FindObject from '@/components/inc/find/findObject'
  import TabHeaderActions from '@/components/inc/tabs/TabHeaderActions'

  export default {
    components: {
      FindObject,
      TabHeaderActions,
    },
    data: () => {
      return {
        access: {
          module_id: Modules.PHP,
          profile_id: Profiles.PERSONAL,
          view_reference: 'crudPHPInterfaces',
          elements: {}
        },
        table : {
          items: [],
          fields: [],
          isBusy: false,
        },
        crud: {
          form: {
            id: 0,
            name: '',
            type: '',
            observations: '',
            active: true,
            module_id: 0,
            module: null,
            height: 0,
            key: '',
          },
        },
        modal: {
          form: {
            active: false,
            title: ''
          },
        },
        constant: {
          type: 'interface'
        },
        conditionModulesActive: [
          {field: 'active', condition: true}
        ],
        isMobileViewport: false,
      }
    },
    created () {
      /* Configurar permisos de vistas y elementos */
      Helper.hasAccessView(this.access)
      /* Fin configuracion */
    },
    mounted() {
      this.mobileMql = window.matchMedia('(max-width: 767.98px)')
      this.isMobileViewport = this.mobileMql.matches
      this.mobileMql.addEventListener('change', this.updateMobileViewport)

      this.loadFieldTable()
      this.load()
    },
    beforeDestroy() {
      if(this.mobileMql) {
        this.mobileMql.removeEventListener('change', this.updateMobileViewport)
      }
    },
    watch: {
      isMobileViewport() {
        this.loadFieldTable()
      }
    },
    methods: {
      updateMobileViewport(e) {
        this.isMobileViewport = e.matches
      },
      alignClass(desktopClass) {
        return this.isMobileViewport ? 'text-left' : desktopClass
      },
      loadFieldTable() {
        this.table.fields = []
        this.table.fields.push({key: 'id', label: 'ID', sortable: true, class: "align-middle " + this.alignClass('text-left')})
        this.table.fields.push({key: 'blocked', label: 'Bloqueado', class: "align-middle " + this.alignClass('text-center')})
        this.table.fields.push({key: 'name', label: 'Nombre', class: "align-middle " + this.alignClass('text-left')})
        this.table.fields.push({key: 'observations', label: 'Observaciones', class: "align-middle " + this.alignClass('text-left')})
        this.table.fields.push({key: 'module', label: 'Módulo', class: "align-middle " + this.alignClass('text-left')})
        this.table.fields.push({key: 'external_url', label: 'URL', class: "align-middle " + this.alignClass('text-center')})
        this.table.fields.push({key: 'log_url', label: 'LOG', class: "align-middle " + this.alignClass('text-center')})
        this.table.fields.push({key: 'f_action', label: this.isMobileViewport ? 'Acción' : '', class: "align-middle " + this.alignClass('text-right'), width: "60px"})
      },
      confirmDialog(message, options) {
        var danger = !!options.danger
        var icon = options.icon || (danger ? 'warning' : 'help')
        var title = this.$createElement('span', { class: 'app-confirm-header__title' }, [
          this.$createElement('AppIcon', { props: { name: icon } }),
          options.title
        ])
        return this.$bvModal.msgBoxConfirm(message, {
          title: title,
          size: 'sm',
          buttonSize: 'sm',
          okVariant: danger ? 'danger' : 'dark',
          okTitle: options.okTitle,
          cancelTitle: options.cancelTitle || 'Cancelar',
          footerClass: 'p-2',
          headerClass: danger ? 'app-confirm-header app-confirm-header--danger' : 'app-confirm-header',
          hideHeaderClose: false,
          centered: true
        })
      },
      getRowCount (items) {
        return items.length
      },
      load() {
        this.table.isBusy = true

        var result = serviceAPI.obtenerPHP(this.constant.type)

        result.then((response) => {
          var data = response.data
          this.table.items = data

          this.table.items.forEach(element => {
            if(!element.blocked) {
              element._rowVariant = 'danger'
            }
          });

          this.table.isBusy = false

          if(this.$refs.table) {
            this.$refs.table.$forceUpdate()
          }
        })
        .catch(error => {
          this.table.isBusy = false
          this.$awn.alert(Error.showError(error))
        });
      },
      getLogUrl(item) {
        return item.log_url + Session.getToken()
      },

      loadModules(object) {
        if(object){
          this.crud.form.module = object
          this.crud.form.module_id = object.id
        } else {
          this.crud.form.module = null
          this.crud.form.module_id = 0
        }
      },

      add() {
        this.crud.form.id = 0
        this.crud.form.name = ''
        this.crud.form.type = this.constant.type
        this.crud.form.observations = ''
        this.crud.form.active = true
        this.crud.form.module = null
        this.crud.form.module_id = 0
        this.crud.form.height = 0
        this.crud.form.key=''

        this.modal.form._id = Math.random().toString(36).slice(2, 8)
        this.modal.form.title = "Nueva Interface"
        this.modal.form.active = true
      },
      edit(item) {
        this.crud.form.id = item.id
        this.crud.form.name = item.name
        this.crud.form.type = item.type
        this.crud.form.observations = item.observations
        this.crud.form.active = true
        this.crud.form.module = item.module
        this.crud.form.module_id = item.module_id
        this.crud.form.height = item.height
        this.crud.form.key = item.key

        this.modal.form._id = Math.random().toString(36).slice(2, 8)
        this.modal.form.title = "Editar Interface"
        this.modal.form.active = true
      },
      remove(item) {
        this.crud.form.id = item.id

        this.confirmDialog('¿Desea borrar el item (' + this.crud.form.id + ') con fecha ' + this.crud.form.name + '?', {
          title: 'Borrar Registro',
          icon: 'delete',
          danger: true,
          okTitle: 'SI',
          cancelTitle: 'NO'
        })
        .then(value => {
          if (value) {
            let loader = this.$loading.show();
            var result = serviceAPI.eliminarPHP(this.crud.form.id);

            result.then((response) => {
              this.modal.form.active = false
              loader.hide()
              this.load()
              this.$awn.success("Registro eliminado");
            })
            .catch(error => {
              loader.hide()
              this.$awn.alert(Error.showError(error));
            })
          }
        })
        .catch(error => {
          this.$awn.alert(Error.showError(error));
        })
      },
      save() {
        let loader = this.$loading.show();

        var result = null
        if (this.crud.form.id) {
          result = serviceAPI.editarPHP(this.crud.form);
        } else {
          result = serviceAPI.agregarPHP(this.crud.form);
        }

        result.then((response) => {
          this.modal.form.active = false
          loader.hide()
          this.load()
          this.$awn.success("Datos guardados con éxito");
        })
        .catch(error => {
          loader.hide()
          this.$awn.alert(Error.showError(error));
        })
      },
      openCode(item) {
        this.$router.push({ name: 'PHPStaffCrudPHPCode', params: {id: item.id}  })
      },
      blockedPHP(item) {
        this.confirmDialog('¿Desea bloquear el bloque de código (' + item.name + ')?', {
          title: 'Bloquear código',
          icon: 'lock-fill',
          okTitle: 'SI',
          cancelTitle: 'NO'
        })
        .then(value => {
          if (value) {
            let loader = this.$loading.show();

            var params = {
              id: item.id,
              blocked: true
            }

            var result = serviceAPI.guardarBlockedPHP(params);

            result.then((response) => {
              loader.hide()
              this.load()
              this.$awn.success("Código bloqueado");
            })
            .catch(error => {
              loader.hide()
              this.$awn.alert(Error.showError(error));
            })
          }
        })
        .catch(error => {
          this.$awn.alert(Error.showError(error));
        })
      },
      unlockedPHP(item) {
        this.confirmDialog('¿Desea desbloquear el bloque de código (' + item.name + ')?', {
          title: 'Desbloquear código',
          icon: 'unlock',
          okTitle: 'SI',
          cancelTitle: 'NO'
        })
        .then(value => {
          if (value) {
            let loader = this.$loading.show();

            var params = {
              id: item.id,
              blocked: false
            }

            var result = serviceAPI.guardarBlockedPHP(params);

            result.then((response) => {
              loader.hide()
              this.load()
              this.$awn.success("Código desbloqueado");
            })
            .catch(error => {
              loader.hide()
              this.$awn.alert(Error.showError(error));
            })
          }
        })
        .catch(error => {
          this.$awn.alert(Error.showError(error));
        })
      },

      openLog(item) {
        const url = this.getLogUrl(item);
        window.open(url, '_blank');
      },
      deleteLog(item) {
        var result = serviceAPI.eliminarPHPLog(item.id);

        result.then((response) => {
          this.$awn.success(response.data);
        })
        .catch(error => {
          this.$awn.alert(Error.showError(error));
        })
      },
    }
  }
</script>
<style>
  /* Kebab con texto "Opciones" visible en mobile (ABM sin drawer: la única
     forma de llegar a Código/Log/Bloquear/Editar/Eliminar es esta acción,
     no puede quedar muda ni oculta). Alineado a la izquierda, como el resto
     del valor apilado. */
  .btn.crud-php-interfaces-action-toggle-labeled {
    display: inline-flex !important;
    align-items: center;
    justify-content: flex-start;
    width: auto !important;
    height: auto !important;
    min-height: 0;
    padding: 0 !important;
    border: none !important;
    background: transparent !important;
    box-shadow: none !important;
    color: var(--app-color-text-secondary) !important;
    font-size: 13px;
    line-height: 1.15;
    white-space: nowrap;
  }
  .btn.crud-php-interfaces-action-toggle-labeled:hover,
  .btn.crud-php-interfaces-action-toggle-labeled:focus {
    color: var(--app-color-primary) !important;
    text-decoration: underline;
  }
  @media (max-width: 767.98px) {
    .crud-php-interfaces-table.app-table.b-table-stacked-md > tbody > tr > td:last-child::before {
      content: attr(data-label) !important;
    }
  }
</style>
